import { Dom, Events, gsap } from '@univers-agency/jupiter'
import uniqueId from 'lodash.uniqueid'

export default class Bubbles {
  constructor (app) {
    this.app = app
  }

  initialize () {
    this.$template = Dom.find('template#hotspot')
    this.$parade = Dom.find('.parade')
    this.$overlayLayer = Dom.find('.layer-overlay')
    this.$clones = []

    gsap.delayedCall(1.2, () => this.findAllHotspots())

    this.initBubbles()
    window.addEventListener(Events.APPLICATION_RESIZE, this.onResize.bind(this))
  }

  initBubbles () {
    Array.from(Dom.all('[data-bubble] [data-popup-close]')).forEach(b => {
      b.addEventListener('click', e => {
        const bubble = b.closest('[data-bubble]')
        bubble.classList.toggle('visible')
        gsap.to(bubble, {
          opacity: 0,
          duration: 0.35,
          onComplete: () => {
            gsap.set(bubble, { display: 'none' })
            this.showMenu()
          }
        })
        this.app.parade.userIsInteracting = false
        if (this.app.parade.autoPaused) {
          this.app.parade.autoPaused = false
          this.app.parade.play()
        }
      })
    })
  }

  showMenu () {
    gsap.to('.menu-button', { autoAlpha: 1 })
  }

  hideMenu () {
    gsap.to('.menu-button', { autoAlpha: 0 })
  }

  findAllHotspots () {
    let pointerVisible = true
    this.$hotspots = Dom.all('[id^="HOTSPOT-"]')
    this.$hotspots.forEach($hotspot => {
      $hotspot.addEventListener('mouseover', () => {
        // pause autoscroll on mouseover!
        if (this.app.parade.playing) {
          this.app.parade.autoPaused = true
          this.app.parade.pause()
        }
      })

      $hotspot.addEventListener('mouseleave', () => {
        if (!this.app.parade.userIsInteracting && this.app.parade.autoPaused) {
          this.app.parade.autoPaused = false
          this.app.parade.play()
        }
      })

      $hotspot.addEventListener('click', e => {
        if (pointerVisible) {
          pointerVisible = false
          const pointer = Dom.find('#POINTER')
          pointer.classList.add('stopped')
          gsap.to(pointer, {
            yPercent: -1000,
            opacity: 0,
            duration: 2,
            ease: 'sine.in',
            onComplete: () => {
              gsap.set(pointer, { display: 'none' })
            }
          })
        }
        this.app.parade.userIsInteracting = true
        const mainRect = this.app.parade.$mainLayer.getBoundingClientRect()
        let y = 0
        let x = 0
        const $target = Dom.find(`[data-bubble="${$hotspot.id}"]`)
        gsap.set($target, { display: 'flex', opacity: 0 })
        const $targetRect = $target.getBoundingClientRect()
        const posToBottom = mainRect.height - e.clientY
        const posToTop = mainRect.height - posToBottom

        if (posToBottom < $targetRect.height) {
          if (posToTop < $targetRect.height) {
            y = (mainRect.height - $targetRect.height) / 2
          } else {
            y = e.clientY - $targetRect.height
          }
        } else {
          y = e.clientY
        }

        x = e.clientX + this.app.parade.$el.scrollLeft
        $target.classList.toggle('visible')

        if (!$target.classList.contains('visible')) {
          gsap.to($target, { opacity: 0, duration: 0.35 })
          this.app.parade.userIsInteracting = false
          if (this.app.parade.autoPaused) {
            this.app.parade.autoPaused = false
            this.app.parade.play()
          }
          this.showMenu()
        } else {
          gsap.set($target, { y, x })
          gsap.to($target, { opacity: 1, duration: 0.35 })
          this.hideMenu()
        }
      })
    })
  }

  getPosition (el) {
    let x = 0
    let y = 0

    while (el != null && (el.tagName || '').toLowerCase() !== 'html') {
      x += el.offsetLeft || 0
      y += el.offsetTop || 0
      el = el.parentElement
    }

    return { x: parseInt(x), y: parseInt(y) }
  }

  repositionDots () {

  }

  onResize () {
  }
}
